<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader"/>
      <rule-game :value="ruleGame"/>
      <rule-game :value="rulePoint"/>
    </div>
  </div>
</template>

<script>
import Board from '../../assets/gamerule/football/Board_FB.png';
import ruleText1 from '../../assets/gamerule/bingo/Bingo_Text1.png';
import ruleFootball1 from '../../assets/gamerule/football/FB_Info_Game_Page_1.png';
import ruleFootball2 from '../../assets/gamerule/football/FB_Info_Game_Page_2.png';
import ruleFootball3 from '../../assets/gamerule/football/FB_Info_Game_Page_3.png';
import ruleFootball4 from '../../assets/gamerule/football/FB_Info_Game_Page_4.png';
import ruleFootball5 from '../../assets/gamerule/football/FB_Info_Game_Page_5.png';
import ruleFootball6 from '../../assets/gamerule/football/FB_Info_Game_Page_9.png';
import ruleFootballscene1 from '../../assets/gamerule/football/FB_Info_Game_Page_6-1.png';
import ruleFootballscene2 from '../../assets/gamerule/football/FB_Info_Game_Page_6-2.png';
import ruleFootballscene3 from '../../assets/gamerule/football/FB_Info_Game_Page_7-1.png';
import ruleFootballscene4 from '../../assets/gamerule/football/FB_Info_Game_Page_7-2.png';
import ruleFootballscene5 from '../../assets/gamerule/football/FB_Info_Game_Page_8-1.png';
import ruleFootballscene6 from '../../assets/gamerule/football/FB_Info_Game_Page_8-2.png';
import ruleBingoAsset2 from '../../assets/gamerule/bingo/Bingo_Asset_Info_Web_Text2.png';

export default {
  name: 'rule_football',
  data() {
    return {
      ruleHeader: {
        gameName: 'นักเตะลูกหนังในตำนาน (Legend of shooter)',
        boardImg: Board,
      },
      ruleGame: [
        {
          type: 'imageNoborder',
          image: ruleText1,
          class: 'w-30',
        },
        {
          type: 'image',
          image: ruleFootball1,
          class: 'w-50',
        },
        {
          type: 'textSubcolor-football',
          textSub: 'เมื่อเข้ามาหน้าเล่นเกมส์ผู้เล่นสามารถเลือกตัวละครจาก (',
          textSubcolor: 'ซ้าย ',
          class1: 'red-color',
          textSub1: '-',
          textSubcolor1: 'ขวา',
          class2: 'yellow-color',
          textSub2: ' ) และกดยืนยัน',
        },
        {
          type: 'image',
          image: ruleFootball2,
          class: 'w-50',
        },
        {
          type: 'textSubcolor-football',
          textSub: '1.เลือกจำนวนรอบเพื่อเล่นในโหมด',
          textSubcolor: 'AUTO',
          class1: 'blue-color',
        },
        {
          type: 'textSubcolor-football',
          textSub: '2.ผู้เล่นจะต้องเลือกมุมที่จะยิงโดยที่ลูกศรตรงกลางจะเคลื่อนที่ตลอดเวลาและจะหยุดเมื่อกด',
          textSubcolor: 'Kick! เพื่อยิง',
          class1: 'yellow-color',
        },
        {
          type: 'image',
          image: ruleFootball3,
          class: 'w-50',
        },
        {
          type: 'textSubcolor-football',
          textSub: 'ปุ่ม',
          textSubcolor: 'AUTO ',
          class1: 'blue-color',
          textSub1: 'หากกดเลือกจำนวนออโต้เรียบร้อยแล้ว และทำการเล่นออโต้ในระหว่างนั้นจะทำการข้ามคัทซีนอัตโนมัติ และระบบจะแสดงจำนวนที่เหลืออยู่ เช่น กดเลือก 10 รอบ ระบบจะนับตั้งแต่ 10 จนถึง 1 และจะหยุดเมื่อครบรอบ สามารถกดหยุดออโต้ได้ด้วยการ กดปุ่ม AUTO ซ้ำอีกครั้ง',
        },
        {
          type: 'image',
          image: ruleFootball4,
          class: 'w-50',
        },
        {
          type: 'textSubcolor-football',
          textSub: '1.ปุ่ม',
          textSubcolor: 'AUTO ',
          class1: 'red-color',
          textSub1: 'ใช้สำหรับเพิ่มจำนวนเดิมพันหรือลดจำนวนเดิมพัน',
        },
        {
          type: 'textSubcolor-football',
          textSub: '2.ปุ่ม',
          textSubcolor: 'FAST MODE ',
          class1: 'green-color',
          textSub1: 'เพื่อปิด Scene โดยขึ้นอยู่กับผู้เล่นว่าต้องการปิดหรือไม่',
        },
        {
          type: 'image',
          image: ruleFootball5,
          class: 'w-50',
        },
        {
          type: 'textSubcolor-football',
          textSub: 'มุมยิงตามลูกศรสีเหลืองชี้ไปทางไหน ลูกบอลก็จะไปทางนั้น มีแบ่งออกเป็น 3 ทางได้แก่',
          textSubcolor: 'ขวา ซ้าย ',
          class1: 'green-color',
          textSub1: 'และ',
          textSubcolor1: ' กลาง ',
          class2: 'red-color',
          textSub2: 'ผลลัพธ์การเตะมีทั้งหมด 4 รูปแบบ ได้แก่ เข้า ออก ชนขอบประตู และเซฟ',
        },
      ],
      rulePoint: [
        {
          type: 'imageNoborder',
          image: ruleBingoAsset2,
          class: 'w-30',
        },
        {
          type: 'twoImage',
          image: ruleFootballscene2,
          class: 'w-90',
          image2: ruleFootballscene1,
        },
        {
          type: 'textSubcolor-football',
          textSub: 'เมื่อผู้เล่นเลือกทิศทางที่จะยิงแล้ว ผู้เล่นจะต้องกดปุ่ม',
          textSubcolor: 'KICK! ',
          class1: 'red-color',
          textSub1: 'และทำการเข้าสู่คัทซีน ในกรณีผู้เล่นข้ามคัทซีนหรือออโต้จะเข้าสู่ฉากเตะบอลทันที',
        },
        {
          type: 'twoImage',
          image: ruleFootballscene4,
          class: 'w-90',
          image2: ruleFootballscene3,
        },
        {
          type: 'textSubcolor-football',
          textSub: 'ในกรณี',
          textSubcolor: 'OUT! ',
          class1: 'red-color',
          textSub1: 'หรือ',
          textSubcolor1: 'SAVE! ',
          class2: 'green-color',
          textSub2: 'ผู้เล่นจะถือว่าแพ้เสียเงินเดิมพันและไม่ได้รับเงิน',
        },
        {
          type: 'twoImage',
          image: ruleFootballscene6,
          class: 'w-90',
          image2: ruleFootballscene5,
        },
        {
          type: 'textSubcolor-football',
          textSub: 'ในกรณี',
          textSubcolor: 'GOAL! ',
          class1: 'yellow-color',
          textSub1: 'ผู้เล่นจะรับเงินที่ BET ไว้ คูณด้วยเลขจากช่องที่เข้า เมื่อเข้าช่องนั้นจะกระพริบแสงสีเหลืองพร้อมแสดงเลขของช่อง และเมื่อเข้า x3 x4 และ x5 จะแสดงอนิเมชั่นต่างกัน',
        },
        {
          type: 'image',
          image: ruleFootball6,
          class: 'w-50',
        },
        {
          type: 'textSubcolor-football',
          textSub: 'เลขของช่อง',
          textSubcolor: 'GOAL! ',
          class1: 'yellow-color',
          textSub1: 'ผู้เล่นสามารถรับเงินได้เมื่อยิงเข้า ช่องมีทั้งหมด 16 ช่อง เมื่อยิงเข้าช่องใดก็ตามจะคิดเป็นกำไรจากราคา BET เช่น BET 100 ยิงเข้าที่ช่อง',
          textSubcolor1: 'X5 ',
          class2: 'red-color',
          textSub2: 'ก็เอา 100 X 5 = 500 คือกำไรของผู้เล่น',
        },
      ],

    };
  },
};
</script>

<style lang="css" scoped>
.white-color {
  color: white;
}

.font-big {
  font-size: 1.8vw;
}
</style>
